import { Screen } from '@rahtab/stack-navigator';
import { Button, Card, CardContainer, Colors, getSpacing, Map, Picker, StepProgressBar, TextInput } from '@rahtab/ui';
import { RouteProp } from '@react-navigation/native';
import React, { VFC } from 'react';
import { KeyboardAvoidingView, ScrollView, StyleSheet, View } from 'react-native';
import { RootStackType } from '../../Router';
import { stepTitles } from './strings';
import { useEdit } from './useEdit';

const completeInfoTitle = 'تکمیل اطلاعات کاربری';
const editInfoTitle = 'ویرایش اطلاعات مکانی';

const EditLocationInfo: VFC<EditLocationInfoProps> = ({ route }) => {
  const disableFieldsInEditInfo = route.name !== 'EditLocationInfo';

  const { edit, editProviderInfo, screenProps } = useEdit(route.name === 'EditLocationInfo' ? 'goBack' : 'home', {
    skipProvinceRequest: !disableFieldsInEditInfo,
  });

  const handleDisableSubmitButton = () => {
    if (route.name === 'CompleteLocationInfo') {
      if (
        !(
          screenProps.data.province &&
          screenProps.data.county &&
          screenProps.data.city &&
          screenProps.data.address &&
          screenProps.data.postalCode
        )
      ) {
        return true;
      }
      return false;
    } else {
      if (!(screenProps.data.address && screenProps.data.postalCode)) {
        return true;
      }
      return false;
    }
  };
  return (
    <Screen
      {...screenProps}
      title={route.name === 'CompleteLocationInfo' ? completeInfoTitle : editInfoTitle}
      renderMain={(data) => {
        const {
          address,
          postalCode,
          region,
          province,
          city,
          county,
          locationInfo: { cities, counties, provinces },
        } = data;
        return (
          <ScrollView keyboardShouldPersistTaps="handled">
            <View style={{ margin: getSpacing() }}>
              <KeyboardAvoidingView>
                <Card>
                  {disableFieldsInEditInfo && (
                    <View
                      style={{
                        backgroundColor: Colors.lightBlue,
                        paddingVertical: getSpacing(),
                      }}>
                      <StepProgressBar currentStep={2} stepsTitle={stepTitles} />
                    </View>
                  )}
                  <CardContainer>
                    {route.name === 'CompleteLocationInfo' && (
                      <>
                        <Picker
                          label="استان"
                          placeholder="استان محل موقعیت پذیرنده را انتخاب نمایید."
                          onSelectValue={(selectedProvince) => {
                            editProviderInfo('province', selectedProvince);
                          }}
                          selectedValue={province}>
                          {provinces.map((p, index) => {
                            return <Picker.Item key={`provinces-${index}`} label={p.label} value={p.value} />;
                          })}
                        </Picker>
                        <Picker
                          label="شهرستان"
                          placeholder="شهرستان محل موقعیت پذیرنده را انتخاب نمایید."
                          onSelectValue={(selectedCounty) => {
                            editProviderInfo('county', selectedCounty);
                          }}
                          selectedValue={county}>
                          {counties.map((c, index) => {
                            return <Picker.Item key={`counties-${index}`} label={c.label} value={c.value} />;
                          })}
                        </Picker>
                        <Picker
                          label="شهر"
                          placeholder="شهر محل موقعیت پذیرنده را انتخاب نمایید."
                          onSelectValue={(c) => editProviderInfo('city', c)}
                          selectedValue={city}>
                          {cities.map((c, index) => {
                            return <Picker.Item key={`cities-${index}`} label={c.label} value={c.value} />;
                          })}
                        </Picker>
                      </>
                    )}
                    {!disableFieldsInEditInfo && (
                      <TextInput value={`${province} | ${county} | ${city}`} editable={false} label="موقعیت" />
                    )}
                    <TextInput
                      value={address}
                      onChangeText={(a) => editProviderInfo('address', a)}
                      placeholder="آدرس پستی موقعیت پذیرنده را وارد کنید."
                      label="آدرس پستی"
                    />
                    <TextInput
                      value={postalCode}
                      onChangeText={(p) => editProviderInfo('postalCode', p)}
                      placeholder="کد پستی پذیرنده را وارد کنید."
                      label="کد پستی"
                    />
                    <Map style={styles.map} region={region} onRegionChange={(r) => editProviderInfo('region', r)} />
                    <Button
                      accessibilityLabel="press to edit"
                      disabled={handleDisableSubmitButton()}
                      onPress={() => {
                        edit();
                      }}
                      color="primary"
                      style={styles.button}
                      text={route.name === 'CompleteLocationInfo' ? 'تکمیل اطلاعات مکانی' : 'ویرایش اطلاعات مکانی'}
                    />
                  </CardContainer>
                </Card>
              </KeyboardAvoidingView>
            </View>
          </ScrollView>
        );
      }}
    />
  );
};

export default EditLocationInfo;

const styles = StyleSheet.create({
  map: {
    height: 300,
  },
  button: {
    marginTop: getSpacing(),
  },
});

interface EditLocationInfoProps {
  route: RouteProp<RootStackType, 'CompleteLocationInfo' | 'EditLocationInfo'>;
}
